// In your React page
import axios from 'axios';
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useContext } from 'react';
import { UserContext } from '../../../context/authContext';
import { SubOptions } from '../../../lib/models/interfaces';

export default function CheckoutPage({
  stripeCustomerId,
  selectedOption,
  customerId,
  setShowOptions,
  setShowPayment
}: {
  stripeCustomerId: string;
  selectedOption: SubOptions | null;
  customerId: string;
  setShowOptions: (arg: boolean) => void;
  setShowPayment: (arg: boolean) => void;
}) {
  const { auth, user } = useContext(UserContext);
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!
  );
  const fetchClientSecret = async () => {
    const res = await axios.post(
      `${process.env.REACT_APP_KORU_API}/checkoutsession`,
      {
        mode: 'subscription', // or 'payment'
        priceId: selectedOption,
        quantity: 1,
        customerId: stripeCustomerId,
        successPath: `${process.env.REACT_APP_BASE_URL}/confirmation`,
        cancelPath: `${process.env.REACT_APP_BASE_URL}/billing/cancel`,
        metadata: { app_customerId: customerId }
      },

      auth
    );
    console.log('res from checkout ======', res);
    const { clientSecret } = res.data;
    return clientSecret;
  };

  return (
    <EmbeddedCheckoutProvider
      stripe={stripePromise}
      options={{ fetchClientSecret }}
    >
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
}
